import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import styles
import './itinerary-item.scss';

//import images and icons
import noImage from "../../../../assets/imgs/no-image.png";
import { ArrowSwapHorizontal, HambergerMenu } from "iconsax-react";
import { BaseButton } from "../../../common/base-button/base-button";

function MobileItineraryItem({ info, handleDescriptionModal, handleReplaceModal }) {
    //general
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid className="mobile-itinerary-item" container item xs={10.5}>
            <Grid className="mobile-itinerary-item__location-image" container item xs={12} justifyContent='space-between' alignItems='flex-start' sx={{ backgroundImage: info.image === '' ? noImage : `url(${'https://api.atripa.com' + info.image})` }}>
                <Grid className="mobile-itinerary-item__location-description" container item xs='auto' onClick={() => handleDescriptionModal(info)}>
                    <HambergerMenu size="24" color="var(--light-color)" variant="Outline" />
                </Grid>

                <Grid className="mobile-itinerary-item__time" container item xs='auto'>
                    <span> {info.start_time.substr(0, 2) + ':' + info.start_time.substr(2, 2)} - {info.end_time.substr(0, 2) + ':' + info.end_time.substr(2, 2)}</span>
                </Grid>
            </Grid>

            <Grid className="mobile-itinerary-item__details" container item xs={12} justifyContent='space-between' alignItems='center'>
                <Grid container item xs={7}><span className="mobile-itinerary-item__location-name">{locale === "en" ? info.name1 : info.name2}</span></Grid>
                <Grid  container item xs={3.75} justifyContent='center' alignItems='center'>
                    <BaseButton
                            text={` ${t("replace")} `}
                            color="primary"
                            size="small"
                            radius="radius-20"
                            rightIcon={<ArrowSwapHorizontal size={20} color="var(--light-color)" />}
                            handleClick={() => handleReplaceModal(info)}
                        />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default MobileItineraryItem;